import { useMemo } from 'react';
import { useTranslation } from '@clubpay/customer-common-module/src/hook/translations';
import { checkIsRestaurantOpen } from '@/services/utils/k_date';
import { useVendor } from '@clubpay/customer-common-module/src/context/vendor';

import styles from './index.module.scss';

const WorkingHoursBanner = () => {
    const { t } = useTranslation('common');
    const { vendor } = useVendor();

    const show = useMemo(() => {
        if (
            !vendor ||
            !vendor.config?.operationalHoursMessageEnable ||
            !vendor.config?.openingHour ||
            !vendor.config?.closingHour
        ) {
            return false;
        }

        return !checkIsRestaurantOpen(vendor.config.openingHour, vendor.config.closingHour);
    }, [vendor]);

    if (show) {
        return <div className={styles.banner}>{t('This restaurant is closed, ordering is currently unavailable')}</div>;
    }
    return null;
};

export default WorkingHoursBanner;
